import {TextField} from '@mui/material'
import {useSnackbar} from 'notistack'
import {useRef} from 'react'

export function MaxWeight({rule, handleUpdateRule}) {
  const {enqueueSnackbar} = useSnackbar()

  const timerRef = useRef(null)
  const inputRef = useRef(null)

  const onChangeHandler = (e) => {
    const value = e.target.value

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      if (value === '' || /^\d+$/.test(value) || /^\d+\.\d{1,2}$/.test(value)) {
        const numValue = value === '' ? '' : parseFloat(value)

        if (rule.shipmentType === 'B2C' && numValue !== '' && numValue > 50) {
          inputRef.current.value = ''
          enqueueSnackbar('Max weight allowed is 50 kg.', {variant: 'error'})
          return
        }

        if (numValue !== '' && numValue < 0.25) {
          inputRef.current.value = ''
          enqueueSnackbar('Max weight must be at least 0.25 kg (250g).', {
            variant: 'error',
          })
          return
        }

        handleUpdateRule({
          advancedSettings: {
            ...rule.advancedSettings,
            maxWeight: value,
          },
        })
      }
    }, 1000)
  }

  return (
    <TextField
      required
      label='Max Weight (kg)'
      type='number'
      defaultValue={rule.advancedSettings.maxWeight}
      inputRef={inputRef}
      onChange={onChangeHandler}
      inputProps={{
        step: '0.1',
        min: '0.25',
        max: rule.shipmentType === 'B2C' ? '50' : undefined,
      }}
      fullWidth
      size='small'
    />
  )
}
